module.exports = __webpack_public_path__ + "static/logo-90f29cab542e2499f33ae0fc3b2a7add.svg";